import { Row, Col } from "antd";
import React, { FC, useEffect, useState } from "react";
import "./css/resourceMain.css";
import RsEarth from "./rsEarth";
import RsChart3 from "./rsChart3";
import RsChart4 from "./rsChart4";
import RsChart1 from "./rsChart1";
import RsChart2 from "./rsChart2";
import RsChart5 from "./rsChart5";
import RsChart6 from "./rsChart6";

const ResourcePanel: React.FC<any> = () => {
  const [curTime, setCurTime] = useState<any>(null);

  useEffect(() => {
    let time = new Date();
    let timeStr = time.toLocaleDateString(); // 转化后的时间：2020/4/22 下午6:54:25
    setCurTime(timeStr);
  }, []);

  return (
    <div id="rs-container">
      <div className="map-mask"></div>
      <div className="rs-title">
        <div id="rs-time"></div>
      </div>
      <div id="charts">
        <div className="rs-left">
          <div className="chart-container">
            <div className="chart-title">
              Global Distribution
              <hr className="rsHr" />
            </div>
            <RsEarth />
          </div>
        </div>
        <div className="rs-right">
          <Row style={{ width: "100%", height: "100%" }}>
            <Col span={12}>
              <Row>
                <Col span={24}>
                  <div className="chart-container">
                    <div className="chart-title">
                      Average Satellite Speed
                      <hr className="rsHr" />
                    </div>
                    <RsChart3 />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="chart-container">
                    <div className="chart-title">
                      Machine Running Status
                      <hr className="rsHr" />
                    </div>
                    <RsChart6 />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="chart-container">
                    <div className="chart-title">
                      Resource Distribution
                      <hr className="rsHr" />
                    </div>
                    <RsChart2 />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row>
                <Col span={24}>
                  <div className="chart-container">
                    <div className="chart-title">
                      Type Distribution
                      <hr className="rsHr" />
                    </div>
                    <RsChart4 />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="chart-container">
                    <div className="chart-title">
                      Work Efficiency
                      <hr className="rsHr" />
                    </div>
                    <RsChart5 />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="chart-container">
                    <div className="chart-title">
                      Communication Link
                      <hr className="rsHr" />
                    </div>
                    <RsChart1 />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ResourcePanel;
